import { Box, Grid, Paper, Typography } from '@mui/material';
import React from 'react';
import {
  AppFormikSelect,
  AppFormikTextArea,
} from 'shared/components/AppComponents';

const PaperFormOperations: React.FC<PaperFormCharacteristicProps> = () => (
  <Box className="paper-form-content">
    <Paper variant="outlined">
      <Typography variant="h6">Operations</Typography>
      <Box className="paper-form-input-content">
        <Grid container spacing={4} className="paper-form-label-input-grid">
          <Grid item md={6} xs={12}>
            <AppFormikTextArea
              outerLabel
              label="Downstream Dependencies"
              placeholder="List dependencies"
              name="downstream"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <AppFormikTextArea
              outerLabel
              label="Review Frequency"
              placeholder="e.g., Quarterly, Annually"
              name="frequency"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <AppFormikTextArea
              outerLabel
              label="Monitoring In Place"
              placeholder="Describe monitoring"
              name="inplace"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <AppFormikSelect
              name="approval"
              className="rework-selection"
              notched={false}
              labelId="fix-selection-label"
              testid="solicitor-dropdown"
              MenuProps={{
                className: 'menu-fix-selection single-fix-rework',
              }}
              outerLabel
              placeholder="Select Approval Status"
              notEmphasized
              notSelectablePlaceholder
              label="Approval Status*"
              items={['Approved', 'Rejected', 'Pending']}
              disabled
            />
          </Grid>
        </Grid>
      </Box>
    </Paper>
  </Box>
);

export default PaperFormOperations;
